export default {
    getSafeArea: function () {
        return Promise.resolve(null);
    },
};
